import { render } from "./dropdown-button.html?vue&type=template&id=2c48da3e&scoped=true&ts=true"
import script from "./dropdown-button.ts?vue&type=script&lang=ts"
export * from "./dropdown-button.ts?vue&type=script&lang=ts"

import "./dropdown-button.scss?vue&type=style&index=0&id=2c48da3e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c48da3e"]])

export default __exports__